export const gameMainItem = [
    { id: 1, title: "Game Development" },
    { id: 2, title: "Game Art" },
    { id: 3, title: "Animation" },
    // { id: 4, title: "Outstaffing" },
];

export const gameDevelopment1 = [
    {
        id: 1,
        image: "/assets/Header/Games/Game Development/White-Label-Crypto-Casino-Solution",
        title: "White-Label Crypto Casino Solution",
        href: "/games/white-label-crypto-casino-solution",
    },
    {
        id: 2,
        image: "/assets/Header/Blockchain/Blockchain Sub/Blockchain Game Development",
        href: "/games/blockchain",
        title: "Blockchain Game Development",
    },
    {
        id: 3,
        image: "/assets/Header/Games/Game Development/Play-To-Earn Game Development",
        title: "Play-To-Earn Game Development",
        href: "/games/play-to-earn",
    },
    {
        id: 4,
        image: "/assets/Header/Games/Game Development/NFT Game Development",
        title: "NFT Game Development",
        href: "/games/nft",
    },
    {
        id: 5,
        image: "/assets/Header/Games/Game Development/Web3 Game Development",
        title: "Web3 Game Development",
        href: "/games/web3",
    },
    {
        id: 6,
        image: "/assets/Header/Games/Game Development/Metaverse Game Development",
        title: "Metaverse Game Development",
        href: "/games/metaverse",
    },
    {
        id: 7,
        image: "/assets/Header/Games/Game Development/Ai Game Development",
        title: "AI Game Development",
        href: "/games/ai",
    },
    {
        id: 8,
        image: "/assets/Header/Games/Game Development/Augmented reality Game",
        title: "Augmented Reality Game Development",
        href: "/games/augmented-reality",
    },
    {
        id: 9,
        image: "/assets/Header/Games/Game Development/Virtual Reality",
        title: "Virtual Reality Game Development",
        href: "/games/virtual-reality",
    },
    {
        id: 10,
        image: "/assets/Header/Games/Game Development/3D Game Development",
        title: "3D Game Development",
        href: "/games/3d",
    },
    {
        id: 11,
        image: "/assets/Header/Games/Game Development/Battle Royale Game Development",
        title: "Battle Royale Game Development",
        href: "/games/battle-royale",
    },
    {
        id: 12,
        image: "/assets/Header/Games/Game Development/Hyper Casual Game Development",
        title: "Hyper Casual Game Development",
        href: "/games/hyper-casual",
    },
];

export const gameDevelopment2 = [
    {
        id: 1,
        image: "/assets/Header/Games/Game Development/Unity Development",
        title: "Unity Development",
        href: "/games/unity",
    },
    {
        id: 2,
        image: "/assets/Header/Games/Game Development/Unreal Development",
        title: "Unreal Development",
        href: "/games/unreal",
    },
    {
        id: 3,
        image: "/assets/Header/Games/Game Development/Mobile Game Development",
        title: "Mobile Game Development",
        href: "/games/mobile",
    },
    {
        id: 4,
        image: "/assets/Header/Games/Game Development/Game Outsourcing",
        title: "Game Development Outsourcing",
        href: "/games/game-development-outsourcing",
    },
    {
        id: 5,
        image: "/assets/Header/Games/Game Development/Mmorpg Game Development",
        title: "Mmorpg Game Development",
        href: "/games/mmorpg",
    },
    {
        id: 6,
        image: "/assets/Header/Games/Game Development/Buildbox Game Development",
        title: "Buildbox Game Development",
        href: "/games/buildbox",
    },
    {
        id: 7,
        image: "/assets/Header/Games/Game Development/Gamification Services",
        title: "Gamification Services",
        href: "/games/gamification-services",
    },
    {
        id: 8,
        image: "/assets/Header/Games/Game Development/CPlusPlusGameDevelopment",
        title: "C++ Game Development",
        href: "/games/c",
    },
    {
        id: 9,
        image: "/assets/Header/Games/Game Development/NFT Desing Company",
        title: "NFT Design Services",
        href: "/games/nft-design-services",
    },
    {
        id: 10,
        image: "/assets/Header/Games/Game Development/Educational Game",
        title: "Educational Game Development",
        href: "/games/education",
    },
    {
        id: 11,
        image: "/assets/Header/Games/Game Development/HTML5 Game Development",
        title: "HTML5 Game Development",
        href: "/games/html5",
    },
    {
        id: 12,
        image: "/assets/Header/Games/Game Development/Social Network Game",
        title: "Social Network Game Development",
        href: "/games/social-network",
    },
];

export const gameDevelopment3 = [
    {
        id: 1,
        image: "/assets/Header/Games/Game Development/2D Game Development",
        title: "2D Game Development",
        href: "/games/2d",
    },
    {
        id: 2,
        image: "/assets/Header/Games/Game Development/Console Game Development",
        title: "Console Game Development",
        href: "/games/console",
    },
    {
        id: 3,
        image: "/assets/Header/Games/Game Development/Cross-Platform",
        title: "Cross-Platform Game Development",
        href: "/games/cross-platform",
    },
    {
        id: 4,
        image: "/assets/Header/Games/Game Development/Game Prototyping",
        title: "Game Prototyping",
        href: "/games/game-prototyping",
    },
    {
        id: 5,
        image: "/assets/Header/Games/Game Development/Game LiveOps Services",
        title: "Game LiveOps Services",
        href: "/games/game-liveops",
    },
    {
        id: 6,
        image: "/assets/Header/Games/Game Development/Co-Development",
        title: "Co Development",
        href: "/games/co-development-game-services",
    },
    {
        id: 7,
        image: "/assets/Header/Games/Game Development/Android Game Development",
        title: "Android Game Development",
        href: "/games/android",
    },
    {
        id: 8,
        image: "/assets/Header/Games/Game Development/iOS Game Development",
        title: "iOS Game Development",
        href: "/games/ios",
    },
    {
        id: 9,
        image: "/assets/Header/Games/Game Development/Game Testing",
        title: "Game Testing",
        href: "/games/game-testing",
    },
    {
        id: 10,
        image: "/assets/Header/Games/Game Development/Game Porting",
        title: "Game Porting",
        href: "/games/game-porting",
    },
    {
        id: 11,
        image: "/assets/Header/Games/Game Development/PC Game Development",
        title: "PC Game Development",
        href: "/games/pc",
    },
];

export const gameArt1 = [
    {
        id: 1,
        image: "/assets/Header/Games/Game Art/Game Economy Design",
        title: "Game Economy Design",
        href: "/game-art/game-economy-design",
    },
    {
        id: 2,
        image: "/assets/Header/Games/Game Art/AAA",
        title: "AAA",
        href: "/game-art/aaa",
    },
    {
        id: 3,
        image: "/assets/Header/Games/Game Art/3D Environment Design",
        title: "3D Environment Design",
        href: "/game-art/3d-environment-design",
    },
    {
        id: 4,
        image: "/assets/Header/Games/Game Art/3D Game Modeling",
        title: "3D Game Modeling",
        href: "/game-art/3d-game-modeling",
    },
    {
        id: 5,
        image: "/assets/Header/Games/Game Art/3D Sculpting",
        title: "3D Sculpting",
        href: "/game-art/3d-sculpting",
    },
    {
        id: 6,
        image: "/assets/Header/Games/Game Art/Character Design",
        title: "Character Design",
        href: "/game-art/character-design",
    },
    {
        id: 7,
        image: "/assets/Header/Games/Game Art/3D Character Design",
        title: "3D Character Design",
        href: "/game-art/3d-character-design",
    },
    {
        id: 8,
        image: "/assets/Header/Games/Game Art/Environment Design",
        title: "Environment Design",
        href: "/game-art/environment-design",
    },
    {
        id: 9,
        image: "/assets/Header/Games/Game Art/2D Environment Design",
        title: "2D Environment Design",
        href: "/game-art/2d-environment-design",
    },
    {
        id: 10,
        image: "/assets/Header/Games/Game Art/2D Characters Design",
        title: "2D Characters Design",
        href: "/game-art/2d-characters-design",
    },
];

export const gameArt2 = [
    {
        id: 1,
        image: "/assets/Header/Games/Game Art/Concept Art",
        title: "Concept Art",
        href: "/game-art/concept-art",
    },
    {
        id: 2,
        image: "/assets/Header/Games/Game Art/UIUX Design",
        title: "UI/UX Design",
        href: "/game-art/ui-ux-design",
    },
    {
        id: 3,
        image: "/assets/Header/Games/Game Art/Game Level Design",
        title: "Game Level Design",
        href: "/game-art/game-level-design",
    },
    {
        id: 4,
        image: "/assets/Header/Games/Game Art/Illustration Services",
        title: "Illustration Services",
        href: "/game-art/illustration-services",
    },
    {
        id: 5,
        image: "/assets/Header/Games/Game Art/Slots Games Art",
        title: "Slots Games Art",
        href: "/game-art/slots-games-art",
    },
    {
        id: 6,
        image: "/assets/Header/Games/Game Art/3D Art",
        title: "3D Art",
        href: "/game-art/3d-art",
    },
    {
        id: 7,
        image: "/assets/Header/Games/Game Art/Hidden Objects",
        title: "Hidden Objects",
        href: "/game-art/hidden-objects",
    },
    {
        id: 8,
        image: "/assets/Header/Games/Game Art/Casual Art",
        title: "Casual Art",
        href: "/game-art/casual-art",
    },
    {
        id: 9,
        image: "/assets/Header/Games/Game Art/2D Art",
        title: "2D Art",
        href: "/game-art/2d-art",
    },
];

// export const gameArt3 = [
// ];

export const animation1 = [
    {
        id: 1,
        image: "/assets/Header/Games/Animation/2D Animation",
        title: "2D Animation",
        href: "/game-animation/2d",
    },
    {
        id: 2,
        image: "/assets/Header/Games/Animation/Pre-Production animation services",
        title: "Pre-Production Animation Services",
        href: "/game-animation/pre-production",
    },
    {
        id: 3,
        image: "/assets/Header/Games/Animation/Asset Production animation services",
        title: "Asset Production Animation Services",
        href: "/game-animation/asset-production",
    },
    {
        id: 4,
        image: "/assets/Header/Games/Animation/3D Animation",
        title: "3D Animation",
        href: "/game-animation/3d",
    },
    {
        id: 5,
        image: "/assets/Header/Games/Animation/Integrated Level Art Production animation services",
        title: "Integrated Level Art Production Animation Services",
        href: "/game-animation/integrated-level-art-production",
    },
    {
        id: 6,
        image: "/assets/Header/Games/Animation/Animation and Visual Effects",
        title: "Animation and Visual Effects",
        href: "/game-animation/animation-and-visual-effects",
    },
    {
        id: 7,
        image: "/assets/Header/Games/Animation/Motion Graphic Animation",
        title: "Motion Graphic Animation",
        href: "/game-animation/motion-graphic",
    },
];

// export const animation2 = [
//   {
//     id: 1,
//     image: "/assets/Header/Games/Animation/3D Animation",
//     title: "3D Animation",
//     href: "/game-animation/3d",
//   },
//   {
//     id: 2,
//     image: "/assets/Header/Games/Animation/Integrated Level Art Production animation services",
//     title: "Integrated Level Art Production animation services",
//     href: "/game-animation/integrated-level-art-production",
//   },
//   {
//     id: 3,
//     image: "/assets/Header/Games/Animation/Animation and Visual Effects",
//     title: "Animation and Visual Effects",
//     href: "/game-animation/animation-and-visual-effects",
//   },
// ];

// export const animation3 = [
//   {
//     id: 1,
//     image: "/assets/Header/Games/Animation/Motion Graphic Animation",
//     title: "Motion Graphic Animation",
//     href: "/game-animation/motion-graphic-animation",
//   },
// ];

export const outstaffing1 = [
    {
        id: 1,
        image: "/assets/Header/Games/Outstaffing/Hire Game Developers",
        title: "Hire Game Developers",
        href: "/game-resources/hire-game-developers",
    },
    {
        id: 2,
        image: "/assets/Header/Games/Outstaffing/Hire Unity Developers",
        title: "Hire Unity Developers",
        href: "/game-resources/hire-unity-developers",
    },
    {
        id: 3,
        image: "/assets/Header/Games/Outstaffing/Hire Unreal Developers",
        title: "Hire Unreal Developers",
        href: "/game-resources/hire-unreal-developers",
    },
    {
        id: 4,
        image: "/assets/Header/Games/Outstaffing/Hire 3D Artists",
        title: "Hire 3D Artists",
        href: "/game-resources/hire-3d-artists",
    },
    {
        id: 5,
        image: "/assets/Header/Games/Outstaffing/Hire 2D Artists",
        title: "Hire 2D Artists",
        href: "/game-resources/hire-2d-artists",
    },
    {
        id: 6,
        image: "/assets/Header/Games/Outstaffing/Hire Illustrators",
        title: "Hire Illustrators",
        href: "/game-resources/hire-illustrators",
    },
];

export const outstaffing2 = [
    {
        id: 1,
        image: "/assets/Header/Games/Outstaffing/Hire 3d Modelers",
        title: "Hire 3d Modelers",
        href: "/game-resources/hire-3d-modelers",
    },
    {
        id: 2,
        image: "/assets/Header/Games/Outstaffing/Hire Game Designer",
        title: "Hire Game Designers",
        href: "/game-resources/hire-game-designers",
    },
    {
        id: 3,
        image: "/assets/Header/Games/Outstaffing/Hire Character Designers",
        title: "Hire Character Designers",
        href: "/game-resources/hire-character-designers",
    },
    {
        id: 4,
        image: "/assets/Header/Games/Outstaffing/Hire Concept Artists",
        title: "Hire Concept Artists",
        href: "/game-resources/hire-concept-artists",
    },
    {
        id: 5,
        image: "/assets/Header/Games/Outstaffing/Hire 2D Animators",
        title: "Hire 2D Animators",
        href: "/game-resources/hire-2d-animators",
    },
    {
        id: 6,
        image: "/assets/Header/Games/Outstaffing/Hire 3D Animators",
        title: "Hire 3D Animators",
        href: "/game-resources/hire-3d-animators",
    },
];

// export const outstaffing3 = [
//   {
//     id: 1,
//     image: "/assets/Header/Games/Outstaffing/Hire 2D Artists",
//     title: "Hire 2D Artists",
//     href: "/game-resources/hire-2d-artists",
//   },
//   {
//     id: 2,
//     image: "/assets/Header/Games/Outstaffing/Hire Illustrators",
//     title: "Hire Illustrators",
//     href: "/game-resources/hire-illustrators",
//   },
//   {
//     id: 3,
//     image: "/assets/Header/Games/Outstaffing/Hire 2D Animators",
//     title: "Hire 2D Animators",
//     href: "/game-resources/hire-2d-animators",
//   },
//   {
//     id: 4,
//     image: "/assets/Header/Games/Outstaffing/Hire 3D Animators",
//     title: "Hire 3D Animators",
//     href: "/game-resources/hire-3d-animators",
//   },
// ];
